// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.10.1
//   protoc               v3.21.12
// source: getcase.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { CaseStatus, caseStatusFromJSON, caseStatusToJSON } from "./schema";

export const protobufPackage = "login";

export interface GetCaseRequest {
  caseId: string;
}

export interface AIRecommendation {
  id: string;
  markdown: string;
  sourceModel: string;
  sourceModelVersion: string;
  reportType: string;
  reviewGenerated: boolean;
}

export interface GetCaseResponse {
  /** Required. The status of case AI job. */
  status: CaseStatus;
  /**
   * Optional. The markdown of the AI response.
   * Deprecated: Use recommendations instead.
   */
  markdown: string;
  recommendations: AIRecommendation[];
  humanAdjudicationId?: string | undefined;
  aiAdjudicationId?:
    | string
    | undefined;
  /** Optional. The provider's original input text. */
  providerInput?:
    | string
    | undefined;
  /** Optional. The survey response rating and comment. */
  surveyResponse?: number | undefined;
  surveyComment?:
    | string
    | undefined;
  /** Optional. Real-time progress messages from the streaming model. */
  progressMessages: string[];
}

function createBaseGetCaseRequest(): GetCaseRequest {
  return { caseId: "" };
}

export const GetCaseRequest: MessageFns<GetCaseRequest> = {
  encode(message: GetCaseRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.caseId !== "") {
      writer.uint32(10).string(message.caseId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCaseRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCaseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.caseId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCaseRequest {
    return { caseId: isSet(object.caseId) ? globalThis.String(object.caseId) : "" };
  },

  toJSON(message: GetCaseRequest): unknown {
    const obj: any = {};
    if (message.caseId !== "") {
      obj.caseId = message.caseId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCaseRequest>, I>>(base?: I): GetCaseRequest {
    return GetCaseRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCaseRequest>, I>>(object: I): GetCaseRequest {
    const message = createBaseGetCaseRequest();
    message.caseId = object.caseId ?? "";
    return message;
  },
};

function createBaseAIRecommendation(): AIRecommendation {
  return { id: "", markdown: "", sourceModel: "", sourceModelVersion: "", reportType: "", reviewGenerated: false };
}

export const AIRecommendation: MessageFns<AIRecommendation> = {
  encode(message: AIRecommendation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.markdown !== "") {
      writer.uint32(18).string(message.markdown);
    }
    if (message.sourceModel !== "") {
      writer.uint32(26).string(message.sourceModel);
    }
    if (message.sourceModelVersion !== "") {
      writer.uint32(34).string(message.sourceModelVersion);
    }
    if (message.reportType !== "") {
      writer.uint32(42).string(message.reportType);
    }
    if (message.reviewGenerated !== false) {
      writer.uint32(48).bool(message.reviewGenerated);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AIRecommendation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAIRecommendation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.markdown = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sourceModel = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sourceModelVersion = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.reportType = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.reviewGenerated = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AIRecommendation {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      markdown: isSet(object.markdown) ? globalThis.String(object.markdown) : "",
      sourceModel: isSet(object.sourceModel) ? globalThis.String(object.sourceModel) : "",
      sourceModelVersion: isSet(object.sourceModelVersion) ? globalThis.String(object.sourceModelVersion) : "",
      reportType: isSet(object.reportType) ? globalThis.String(object.reportType) : "",
      reviewGenerated: isSet(object.reviewGenerated) ? globalThis.Boolean(object.reviewGenerated) : false,
    };
  },

  toJSON(message: AIRecommendation): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.markdown !== "") {
      obj.markdown = message.markdown;
    }
    if (message.sourceModel !== "") {
      obj.sourceModel = message.sourceModel;
    }
    if (message.sourceModelVersion !== "") {
      obj.sourceModelVersion = message.sourceModelVersion;
    }
    if (message.reportType !== "") {
      obj.reportType = message.reportType;
    }
    if (message.reviewGenerated !== false) {
      obj.reviewGenerated = message.reviewGenerated;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AIRecommendation>, I>>(base?: I): AIRecommendation {
    return AIRecommendation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AIRecommendation>, I>>(object: I): AIRecommendation {
    const message = createBaseAIRecommendation();
    message.id = object.id ?? "";
    message.markdown = object.markdown ?? "";
    message.sourceModel = object.sourceModel ?? "";
    message.sourceModelVersion = object.sourceModelVersion ?? "";
    message.reportType = object.reportType ?? "";
    message.reviewGenerated = object.reviewGenerated ?? false;
    return message;
  },
};

function createBaseGetCaseResponse(): GetCaseResponse {
  return {
    status: 0,
    markdown: "",
    recommendations: [],
    humanAdjudicationId: undefined,
    aiAdjudicationId: undefined,
    providerInput: undefined,
    surveyResponse: undefined,
    surveyComment: undefined,
    progressMessages: [],
  };
}

export const GetCaseResponse: MessageFns<GetCaseResponse> = {
  encode(message: GetCaseResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.markdown !== "") {
      writer.uint32(18).string(message.markdown);
    }
    for (const v of message.recommendations) {
      AIRecommendation.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.humanAdjudicationId !== undefined) {
      writer.uint32(34).string(message.humanAdjudicationId);
    }
    if (message.aiAdjudicationId !== undefined) {
      writer.uint32(42).string(message.aiAdjudicationId);
    }
    if (message.providerInput !== undefined) {
      writer.uint32(50).string(message.providerInput);
    }
    if (message.surveyResponse !== undefined) {
      writer.uint32(56).int32(message.surveyResponse);
    }
    if (message.surveyComment !== undefined) {
      writer.uint32(66).string(message.surveyComment);
    }
    for (const v of message.progressMessages) {
      writer.uint32(74).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCaseResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCaseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.markdown = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.recommendations.push(AIRecommendation.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.humanAdjudicationId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.aiAdjudicationId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.providerInput = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.surveyResponse = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.surveyComment = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.progressMessages.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCaseResponse {
    return {
      status: isSet(object.status) ? caseStatusFromJSON(object.status) : 0,
      markdown: isSet(object.markdown) ? globalThis.String(object.markdown) : "",
      recommendations: globalThis.Array.isArray(object?.recommendations)
        ? object.recommendations.map((e: any) => AIRecommendation.fromJSON(e))
        : [],
      humanAdjudicationId: isSet(object.humanAdjudicationId)
        ? globalThis.String(object.humanAdjudicationId)
        : undefined,
      aiAdjudicationId: isSet(object.aiAdjudicationId) ? globalThis.String(object.aiAdjudicationId) : undefined,
      providerInput: isSet(object.providerInput) ? globalThis.String(object.providerInput) : undefined,
      surveyResponse: isSet(object.surveyResponse) ? globalThis.Number(object.surveyResponse) : undefined,
      surveyComment: isSet(object.surveyComment) ? globalThis.String(object.surveyComment) : undefined,
      progressMessages: globalThis.Array.isArray(object?.progressMessages)
        ? object.progressMessages.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetCaseResponse): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = caseStatusToJSON(message.status);
    }
    if (message.markdown !== "") {
      obj.markdown = message.markdown;
    }
    if (message.recommendations?.length) {
      obj.recommendations = message.recommendations.map((e) => AIRecommendation.toJSON(e));
    }
    if (message.humanAdjudicationId !== undefined) {
      obj.humanAdjudicationId = message.humanAdjudicationId;
    }
    if (message.aiAdjudicationId !== undefined) {
      obj.aiAdjudicationId = message.aiAdjudicationId;
    }
    if (message.providerInput !== undefined) {
      obj.providerInput = message.providerInput;
    }
    if (message.surveyResponse !== undefined) {
      obj.surveyResponse = Math.round(message.surveyResponse);
    }
    if (message.surveyComment !== undefined) {
      obj.surveyComment = message.surveyComment;
    }
    if (message.progressMessages?.length) {
      obj.progressMessages = message.progressMessages;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCaseResponse>, I>>(base?: I): GetCaseResponse {
    return GetCaseResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCaseResponse>, I>>(object: I): GetCaseResponse {
    const message = createBaseGetCaseResponse();
    message.status = object.status ?? 0;
    message.markdown = object.markdown ?? "";
    message.recommendations = object.recommendations?.map((e) => AIRecommendation.fromPartial(e)) || [];
    message.humanAdjudicationId = object.humanAdjudicationId ?? undefined;
    message.aiAdjudicationId = object.aiAdjudicationId ?? undefined;
    message.providerInput = object.providerInput ?? undefined;
    message.surveyResponse = object.surveyResponse ?? undefined;
    message.surveyComment = object.surveyComment ?? undefined;
    message.progressMessages = object.progressMessages?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
